import { WidgetSize } from '@wix/wix-chatbot-common/browser';

import { TRootState } from '../../common/reducers';
import { renderModel } from '../../util/renderModel';

const isFullWidth = renderModel.isFullWidth();

const enum KbWidgetState {
  WidgetOpen = 'widget_open',
  WidgetClosed = 'widget_closed',
  WidgetMaximized = 'widget_maximize',
  FullPageSidebarExtended = 'full_page_extended',
  FullPageSidebarOpen = 'full_page_opened',
}

export function getKbWidgetState(state: TRootState): KbWidgetState | undefined {
  if (isFullWidth) {
    return getFullPageState(state);
  }

  const { expanded, size } = state.widget;

  if (expanded) {
    return size === WidgetSize.Maximized ? KbWidgetState.WidgetMaximized : KbWidgetState.WidgetOpen;
  } else {
    return KbWidgetState.WidgetClosed;
  }
}

export function getFullPageState(state: TRootState): KbWidgetState | undefined {
  const { fullPageSidebarExtended, fullPageSidebarOpened } = state.helpCenter;

  if (fullPageSidebarExtended) {
    return KbWidgetState.FullPageSidebarExtended;
  }

  if (fullPageSidebarOpened) {
    return KbWidgetState.FullPageSidebarOpen;
  }
}
